
import React from 'react';
import { Icon } from "semantic-ui-react";

function TheIcon (props) {
  return <Icon name="key" {...props} />;
}

export const meta = {
  id: 'TenantKeysDetails',
  title: 'TenantKeysDetails',
  // category: '',
  unique: false,
  icon: TheIcon,
  version: '1.0.0',
  description: `The module to deal with the API Keys for each given tenant.`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    width: 550,
    height: 720
  }
};
